var setSiteCookies;

setSiteCookies = require('./setSiteCookies');

Groupon.setWindowLocation = require('./setWindowLocation');

module.exports = Groupon.Utils.changeUserLanguage = function(language) {
  var alternate, href, hreflang;
  setSiteCookies({
    user_locale: null
  });
  setSiteCookies({
    user_locale: language
  });
  hreflang = "[hreflang='" + language.replace('_', '-') + "']";
  if ((alternate = $("head link" + hreflang).attr("href"))) {
    href = alternate;
  } else {
    href = '/';
  }
  return Groupon.setWindowLocation(href);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9jaGFuZ2VVc2VyTGFuZ3VhZ2UuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9jaGFuZ2VVc2VyTGFuZ3VhZ2UuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxHQUFpQixPQUFBLENBQVEsa0JBQVI7O0FBQ2pCLE9BQU8sQ0FBQyxpQkFBUixHQUE0QixPQUFBLENBQVEscUJBQVI7O0FBRTVCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLE9BQU8sQ0FBQyxLQUFLLENBQUMsa0JBQWQsR0FBbUMsU0FBQyxRQUFEO0FBQ2xELE1BQUE7RUFBQSxjQUFBLENBQWU7SUFBQSxXQUFBLEVBQWEsSUFBYjtHQUFmO0VBQ0EsY0FBQSxDQUFlO0lBQUEsV0FBQSxFQUFhLFFBQWI7R0FBZjtFQUNBLFFBQUEsR0FBVyxhQUFBLEdBQWdCLFFBQVEsQ0FBQyxPQUFULENBQWlCLEdBQWpCLEVBQXNCLEdBQXRCLENBQWhCLEdBQTZDO0VBRXhELElBQUcsQ0FBQyxTQUFBLEdBQVksQ0FBQSxDQUFFLFdBQUEsR0FBYyxRQUFoQixDQUF5QixDQUFDLElBQTFCLENBQStCLE1BQS9CLENBQWIsQ0FBSDtJQUNFLElBQUEsR0FBTyxVQURUO0dBQUEsTUFBQTtJQUdFLElBQUEsR0FBTyxJQUhUOztTQUtBLE9BQU8sQ0FBQyxpQkFBUixDQUEwQixJQUExQjtBQVZrRCJ9
